async function readTag() {
  clearLog();
  if ("NDEFReader" in window) {
    const ndef = new NDEFReader();
    StatusLog("Ready");
    document.getElementById("ReadBtn").disabled = true;
    try {
      await ndef.scan();
      ndef.onreading = event => {
        const decoder = new TextDecoder();
        for (const record of event.message.records) {
          consoleLog(decoder.decode(record.data));
        }
      }
    } catch(error) {
      consoleLog(error);
    }
  } else {
    StatusLog("Web NFC is not supported.");
  }
}

function StatusLog(data) {
  var logStatus = document.getElementById('log');
  logStatus.innerHTML += data;

}
function consoleLog(data) {
  var logField = document.getElementById('chl');
  logField.value += data;
}

function QrCode() {
 var link = document.getElementById('chl').value;
 document.getElementById("qrtest").innerHTML = "";
 var qr = "https://chart.apis.google.com/chart?cht=qr&chs=400x400&choe=UTF-8&chld=H&chl=" + link;
  document.getElementById("qrtest").innerHTML += '<img src="'+qr+'">';
}


function clearLog() {
        document.getElementById("chl").value = "";
}
